import { useCallback, useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache the map image data URL once per browser tab so we don't re-fetch
// the (potentially large) base64 image on every open.
let _cached = null;

export function useIslandMap() {
  const [mapUrl, setMapUrl] = useState(_cached);
  const [loading, setLoading] = useState(!_cached);
  const [error, setError] = useState(null);

  const fetchMap = useCallback(async (regenerate = false) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/sprites/map${regenerate ? '?regenerate=true' : ''}`);
      if (!res.ok) throw new Error(`Map request failed: ${res.status}`);
      const data = await res.json();
      _cached = data.data_url;
      setMapUrl(data.data_url);
    } catch (e) {
      setError(e.message || 'Failed to load map');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!_cached) fetchMap(false);
  }, [fetchMap]);

  return { mapUrl, loading, error, refresh: () => fetchMap(false), regenerate: () => fetchMap(true) };
}
